export default __webpack_public_path__ + "static/media/gd.5c157999.png";